module.exports = __webpack_public_path__ + "static/media/phone-number.61139aab.svg";